import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-white py-10 sm:py-16" aria-labelledby="guarantee-heading" data-id="element-119" data-mp="4uqcgsut9wrq">
      <div className="mx-auto max-w-2xl px-5 sm:px-6" data-id="element-120" data-mp="9ttgc9z21wy4">
        <div className="flex items-start gap-4 rounded-2xl border border-line border-t-4 border-t-gold bg-canvas p-5 sm:gap-6 sm:p-8" data-id="element-121" data-mp="9wfs6lszaym5">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold text-navy sm:h-14 sm:w-14" aria-hidden="true" data-id="element-122" data-mp="jt294zi6p5iw">
            <ShieldCheckIcon className="h-6 w-6 sm:h-7 sm:w-7" strokeWidth={2} data-id="element-123" data-mp="nsb3a5h4z5ez" />
          </span>
          <div data-id="element-124" data-mp="sldwgci04cun">
            <h2 id="guarantee-heading" className="font-display text-xl font-bold leading-tight text-navy sm:text-2xl" data-id="element-125" data-mp="smxea7jb2vyj">
              7-Day 100% Satisfaction Guarantee
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-body sm:text-base" data-id="element-126" data-mp="12kv42zgtd0t9">
              Download everything and use it in your coaching. If within 7 days
              it isn’t clear, practical or useful for you, contact us —{' '}
              <span className="font-bold text-navy" data-id="element-127" data-mp="20t3uerip6wx8">
                full refund, no questions asked.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}